import { render, staticRenderFns } from "./q3.vue?vue&type=template&id=6319df96&"
import script from "./q3.vue?vue&type=script&lang=js&"
export * from "./q3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports